export default [
  {
    url: "",
    title: "xiaohongshu",
    icon: "https://weapp.soutuya.com/static/images/xiaohongshu.png",
  },
  {
    url: "",
    title: "instagram",
    icon: "https://weapp.soutuya.com/static/images/instagram.png",
  },
  {
    url: "",
    title: "douyin",
    icon: "https://weapp.soutuya.com/static/images/douyin.png",
  },
  {
    url: "",
    title: "kuaishou",
    icon: "https://weapp.soutuya.com/static/images/kuaishou.ico",
  },
  {
    url: "",
    title: "xigua",
    icon: "https://weapp.soutuya.com/static/images/xigua.png",
  },
  {
    url: "",
    title: "huoshan",
    icon: "https://weapp.soutuya.com/static/images/huoshan.jpg",
  },
  {
    url: "",
    title: "meipai",
    icon: "https://weapp.soutuya.com/static/images/meipai.jpg",
  },
  {
    url: "",
    title: "pipixia",
    icon: "https://weapp.soutuya.com/static/images/pipixia.jpg",
  },
  {
    url: "",
    title: "yingke",
    icon: "https://weapp.soutuya.com/static/images/yingke.jpg",
  },
  {
    url: "",
    title: "momo",
    icon: "https://weapp.soutuya.com/static/images/momo.jpg",
  },
  {
    url: "",
    title: "xiaokaxiu",
    icon: "https://weapp.soutuya.com/static/images/xiaokaxiu.jpg",
  },
  {
    url: "",
    title: "weishi",
    icon: "https://weapp.soutuya.com/static/images/weishi.jpg",
  },
  {
    url: "",
    title: "miaopai",
    icon: "https://weapp.soutuya.com/static/images/miaopai.jpg",
  },
  {
    url: "",
    title: "quduopai",
    icon: "https://weapp.soutuya.com/static/images/quduopai.jpg",
  },
  {
    url: "",
    title: "quanmin",
    icon: "https://weapp.soutuya.com/static/images/quanmin.jpg",
  },
  {
    url: "",
    title: "xianyu",
    icon: "https://weapp.soutuya.com/static/images/xianyu.jpg",
  },
  // {
  //   url: "",
  //   title: "twitter",
  //   icon: "https://douyin201901.gz.bcebos.com/images/twitter.jpg",
  // },
];
